import React from 'react';
import { HeroBackdrop } from './BackgroundGraphics';

function PageHero({ tag, title, titleAccent, description, children, compact = false }) {
  return (
    <HeroBackdrop className={compact ? 'pt-28 pb-16 md:pt-32 md:pb-20' : 'pt-28 pb-20 md:pt-36 md:pb-28'}>
      <div className="mx-auto max-w-4xl px-6 text-center">
        {tag && (
          <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-accent">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary" />
            {tag}
          </span>
        )}
        <h1 className="text-4xl font-black leading-[1.05] tracking-tight text-white md:text-5xl lg:text-6xl">
          {title}
          {titleAccent && (
            <>
              <br />
              <span className="text-primary">{titleAccent}</span>
            </>
          )}
        </h1>
        {description && (
          <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-silver md:text-lg">
            {description}
          </p>
        )}
        {children && <div className="mt-8 flex flex-wrap items-center justify-center gap-3">{children}</div>}
      </div>
    </HeroBackdrop>
  );
}

export default PageHero;
